/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment } from 'react';
import BlogCard from '../shared/cards/BlogCard';
import CaseStudyCard from '../shared/cards/CaseStudyCard';
import CourseCard from '../shared/cards/CourseCard';
import EventCard from '../shared/cards/EventCard';
import PressReleaseCard from '../shared/cards/PressReleaseCard';
import ReportCard from '../shared/cards/ReportCard';
import SuccessStory from '../shared/cards/SuccessStoryCard';
import WebinarCard from '../shared/cards/WebinarCard';
import Mention from '../shared/cards/Mention';
import NewsletterCard from '../shared/cards/NewsletterCard';
const Content = ({ items, newsletterGuid, siteId, newsletterConfig }) => {
    function renderCard(item) {
        let ItemComponent;
        switch (item.pageType) {
            case 'xperience.event':
                ItemComponent = EventCard;
                break;
            case 'xperience.trainingcourse':
                ItemComponent = CourseCard;
                break;
            case 'xperience.webinar':
                ItemComponent = WebinarCard;
                break;
            case 'xperience.pressrelease':
                ItemComponent = PressReleaseCard;
                break;
            case 'xperience.report':
                ItemComponent = ReportCard;
                break;
            case 'xperience.casestudy':
                ItemComponent = CaseStudyCard;
                break;
            case 'xperience.successstory':
                ItemComponent = SuccessStory;
                break;
            case 'xperience.mention':
                ItemComponent = Mention;
                break;
            case 'xperience.blogpost':
            default:
                ItemComponent = BlogCard;
                break;
        }
        return React.createElement(ItemComponent, { ...item, key: item.id });
    }
    return (React.createElement(Fragment, null, items.map((item, index) => index === 4 && !newsletterConfig.contactSubscribedToNewsletter
        ? [
            React.createElement(NewsletterCard, { ...item, key: index, newsletterGuid: newsletterGuid, siteId: siteId, newsletterConfig: newsletterConfig }),
            renderCard(item),
        ]
        : renderCard(item))));
};
export default Content;
